import React, { createContext, useContext, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  GET_BG_ACCOUNT_BY_BG_ID,
  GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT,
} from "../graphql/query";
import UserContext from "../context/UserContext";
interface PlanContextType {
  currentPlan: any;
  setCurrentPlan: (plan: string) => void;
  data1: any;
}
const PlanContext = createContext<PlanContextType | undefined>(undefined);
export const PlanProvider: React.FC<any> = ({ children }) => {
  const [currentPlan, setCurrentPlan] = useState<any>();
  const { currentUserRole } = useContext(UserContext);
  const {
    loading: loading1,
    error: error1,
    data: data1,
  } = useQuery(GET_BG_ACCOUNT_BY_BG_ID, {
    skip:
      currentUserRole.agent ||
      currentUserRole.operator ||
      currentUserRole.franchiseAdmin ||
      Object.values(currentUserRole).every((val: any) => !val),
  });

  const {
    loading: loading2,
    error: error2,
    data: data2,
  } = useQuery(GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT, {
    variables: {
      input: {
        bgAccountId: Number(data1?.getBgAccountById?.id),
      },
    },
    skip:
      (!currentUserRole.salesManager &&
        !currentUserRole.salesAssociate &&
        currentUserRole.franchiseAdmin &&
        currentUserRole.agent &&
        currentUserRole.operator &&
        !currentUserRole.admin) ||
      !data1?.getBgAccountById?.id, // Skip the query if currentUser is not admin or bgAccountId is null or undefined
    context: {
      headers: {
        "access-control-allow-methods": "AdminPermission",
      },
    },
  });

  React.useEffect(() => {
    if (!loading2 && !error2 && data2) {
      setCurrentPlan(data2?.getcurrentPlanAndBillingDetailsByBgAccount);
    }
  }, [data2]);
  if (loading1) {
    return <>Loading...</>;
  }

  if (error1) {
    console.log(error1);
  }
  if (data2) {
    console.log(data2);
  }

  const contextValue: PlanContextType = {
    currentPlan,
    setCurrentPlan,
    data1,
  };
  return (
    <PlanContext.Provider value={contextValue}>{children}</PlanContext.Provider>
  );
};

export const usePlan = () => {
  const context = useContext(PlanContext);
  if (context === undefined) {
    throw new Error("usePlan must be used within a PlanProvider");
  }
  return context;
};
